import { useNavigate } from "react-router-dom";
import Navigator from "./Navigator";
const List = ({ data }) => {

    const navigate = useNavigate();

    return (
        <div className=" row row-cols-2 justify-content-between">
            {data.map(item => (
                <div 
                    className="col-md-6 col-12 " key={item.id}
                    onClick={() => navigate(`/portafolio/${item.id}`)}
                >
                    <div className="window mb-4 ">
                        <Navigator title={item.title} />
                        <div className="img-container">
                            <img src={item.image} alt={item.title} />
                        </div>
                        <div className="tags">
                            {item.tags.split(',').map(tag => (
                                <strong className="badge bg-dark me-2" key={tag}>
                                    {tag}
                                </strong>
                            ))}
                        </div>

                    </div>

                </div>
            ))}

        </div>
    )
}

export default List;
